import { createDocsInsightsReport } from './api';
import { countUpAiUsage } from './countUpAiUsage';

/**
 * 指定されたファイルリストとサービス名をもとに、レポート作成リクエストを送信します。
 * AI使用回数のカウントアップやレポート作成に失敗した場合は false を返します。
 *
 * @param importFileList レポート作成対象となるファイル名の配列（例: ['sample1.xlsx', 'sample2.xlsx']）
 * @param service 利用するサービス名（例: 'insightReporter'）
 * @returns レポート作成リクエストが成功した場合は true、失敗した場合は false
 */
export const requestReportCreate = async (
    importFileList: string[],
    service: string
): Promise<boolean> => {
    if (!(await countUpAiUsage(service))) return false;
    try {
        const { isSuccess } = await createDocsInsightsReport(importFileList, service);
        return isSuccess;
    } catch {
        return false;
    }
};